import api from '@/core/apiclient'
import {actionTypes} from '@/core/constants'

export default {

    async [actionTypes.GALERIA_PACIENTE.BUSCAR_MIDIAS_PACIENTE]({state}, pacienteId) {
        const {filtros, paginacao} = state.resultadoBuscaTodasMidias
        filtros.pacienteId.value = pacienteId
        const {data} = await api.galeria.buscarMidias(filtros, paginacao)
        return data
    },

    async [actionTypes.GALERIA_PACIENTE.ENVIAR_MIDIA_PACIENTE](context, dados) {
        const {data} = await api.galeria.enviar(dados)
        return data
    },

    async [actionTypes.GALERIA_PACIENTE.REMOVER_MIDIA_PACIENTE](context, id) {
        await api.galeria.excluir(id)
    },

    async [actionTypes.GALERIA_PACIENTE.GERAR_TOKEN_QR_CODE](context, pacienteId) {
        const {data} = await api.galeria.gerarTokenQRCode(pacienteId)
        return data
    },

    async [actionTypes.GALERIA_PACIENTE.ENVIAR_MIDIA_PUBLIC_TOKEN](context, dados) {
        const {data} = await api.galeria.enviarMidiaPublicToken(dados)
        return data
    },
}